import { render, staticRenderFns } from "./SlideBar.vue?vue&type=template&id=665ec79b&scoped=true&"
import script from "./SlideBar.vue?vue&type=script&lang=js&"
export * from "./SlideBar.vue?vue&type=script&lang=js&"
import style0 from "./SlideBar.vue?vue&type=style&index=0&id=665ec79b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ec79b",
  null
  
)

export default component.exports